var image_ratio = 1;
var cropper;
var is_init_cropper = false;
var height_cm = "";
var width_cm = "";
var height_inch = "";
var width_inch = "";
var isMirrored = false;


function destroyy(){
    var cropBox = document.querySelector('.cropper-container.cropper-bg');
    if (cropBox) {
    cropBox.remove();
  }
  if (cropper) {
    cropper.destroy();
    cropper = null; 
    is_init_cropper = false;

  }
  $('body.product-logic-2 .productView-image-wrapper .productView-nav , body.product-logic-2  .productView-thumbnail-wrapper').show();
  $('body.product-logic-2 .productView-image-wrapper .productView-nav').slick('refresh');
  $('.cropper-container-my , body.product-logic-2 .croper_main_image-txt').hide();
}

function updatePrice() {
    var priceText = $('.productView-price .price span.price-item').html();
    $('.aamount_sdd').html(`${priceText} USD`);

    if ($("button#product-add-to-cart .appended_prices").length > 0) {
        $("button#product-add-to-cart .appended_prices").html(`${priceText} USD`);
    } else {
        $("button#product-add-to-cart").append(`<span class="appended_prices">${priceText} USD</span>`);
    }

    destroyy();
    $('input#SizeCustom').val('');
    $('input.send_data').val(1);
}



function init_cropper() {
    $('.cropper-container-my').show();
      setTimeout(function() {
       $('.cropper-container.cropper-bg:eq(0) , body.product-logic-2 .croper_main_image-txt').show();
      }, 100);  
    $('body.product-logic-2 .productView-image-wrapper .productView-nav , body.product-logic-2  .productView-thumbnail-wrapper').hide();
    if (cropper) {
        cropper.destroy();
        cropper = null;  
        is_init_cropper = false;
    }

    var image = document.querySelector('.cropper-container-my .crop_image_main');
   
    var width_m = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__ft.surface_dimension_input input").val()) || 0;
    var height_m = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__ft.surface_dimension_input input').val()) || 0;
    var width_in = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input').val()) || 0;
    var height_in = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val()) || 0;
    if ($(".surface-unit__item--in").hasClass("surface-unit__item--active")) {
    width_m = width_in + parseFloat(width_m * 12);
    height_m = height_in + parseFloat(height_m * 12);
    }
    else{
    width_m = parseFloat(((width_m * 100) + parseInt(width_in))/100);
    height_m = parseFloat(((height_m * 100) + parseInt(height_in))/100);
    }

    image_ratio = width_m / height_m;

    if (document.querySelector('.cropper-container')) {
        document.querySelector('.cropper-container').remove(); 
    }

    cropper = new Cropper(image, {
        aspectRatio: image_ratio,
        viewMode: 1,
        center: false,
        zoomable: false,
        checkCrossOrigin: true,
        checkOrientation: false,
        dragMode: "none",
        autoCropArea: 1,
        rotatable: true,
        cropBoxResizable: true,
        scalable: true,
        movable: false,
        ready: function () {
            croppable = true;
        },
    });

    is_init_cropper = true;  
  $('.cropper-container-my .cropper-container.cropper-bg:eq(0)').show();
}



function uploadImage(base64Image) {
    const url = 'https://order.wallseason.com/'; 
   
    const formData = new FormData();
    formData.append('image', base64Image);

    // Send the POST request using Fetch API
    fetch(url, {
        method: 'POST',
        body: formData,
    })
    .then(response => response.json())
    .then(data => {
        var imgg = data.image_link;
        console.log('Crop image : ',imgg)
       $('input#CropPath').attr('value',imgg);
    })
    .catch((error) => {
        console.log('Error uploading image:', error);
    });
}



function resetcropper(){
  $('.surface-popup__action input').val(0);
  var cropBox = document.querySelector('.cropper-container.cropper-bg');
  if (cropBox) {
    cropBox.remove();
  }
  if (cropper) {
    cropper.destroy();
    cropper = null; 
    is_init_cropper = false;

  }
  $('body.product-logic-2 .productView-image-wrapper .productView-nav , body.product-logic-2  .productView-thumbnail-wrapper').show();
  $('.cropper-container-my , body.product-logic-2 .croper_main_image-txt').hide();
  $('input#SizeCustom').val('');
  $('input#CropPath').val('');
  $('.surface_space_row .quantity_selector quantity-input .quantity__container input').val(1);
  var priceText = $('.productView-price .price.price--medium span.price-item').html();
  $('span.aamount_sdd , span.appended_prices').html(priceText+' USD').show();
  $('input.send_data').val(1);
  
  
}

function convert_into(w, h, type) {
    if (type == "cm") {
      return Math.ceil(w * h * 0.00107639104167);
    } else if (type == "inches") {
      // return Math.ceil(w * h * 0.00694444444444);
      return Math.ceil(w * h);
    } else if (type == "unitfeet") {
      return Math.ceil(w * h);
    }
  }


function convertToSquareFeet() {
      var widthIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input').val()) || 0;
      var widthFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__ft.surface_dimension_input input").val()) || 0;
      var heightFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__ft.surface_dimension_input input").val()) || 0;
      var heightIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val()) || 0;
  
  
    // Convert height to total feet
    const totalHeight = heightFt + (heightIn / 12);
    
    // Convert width to total feet
    const totalWidth = widthFt + (widthIn / 12);
    
    // Calculate area in square feet
    const area = totalHeight * totalWidth;
    
    return area;
}


  $(document).on('click','a.surface-unit__item',function(){
      $(this).addClass('surface-unit__item--active').siblings().removeClass('surface-unit__item--active');
      if($(this).hasClass('surface-unit__item--cm')){
      $('span.ft1 , span.ft2').html('m')
      $('.not-for-cm').hide();
      $('span.inch1,span.inch2').html('cm')
      }
      else{
      $('span.ft1 , span.ft2').html('ft')
      $('.not-for-cm').show();
      $('span.inch1,span.inch2').html('in')
      }
      resetcropper()
  });



// Debounce function
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function centerCropBox() {
  const cropBoxData = cropper.getCropBoxData(); // Get current crop box data
  const containerData = cropper.getContainerData(); // Get container data (image container)

  // Define the width and height as 80% of the container
  const reducedWidth = containerData.width * 0.8;
  const reducedHeight = containerData.height * 0.8;

  // Calculate the center position for the crop box
  const newLeft = (containerData.width - reducedWidth) / 2;
  const newTop = (containerData.height - reducedHeight) / 2;

  // Adjust the crop box size and position, ensuring it stays within the bounds
  cropper.setCropBoxData({
    width: reducedWidth,
    height: reducedHeight,
    left: Math.max(0, newLeft), // Ensure left position is not negative
    top: Math.max(0, newTop) // Ensure top position is not negative
  });

  // Optionally, check if the crop box overflows and correct it
  const adjustedCropBoxData = cropper.getCropBoxData();

  if (adjustedCropBoxData.left + adjustedCropBoxData.width > containerData.width) {
    cropper.setCropBoxData({ left: containerData.width - adjustedCropBoxData.width });
  }

  if (adjustedCropBoxData.top + adjustedCropBoxData.height > containerData.height) {
    cropper.setCropBoxData({ top: containerData.height - adjustedCropBoxData.height });
  }
}


$(document).ready(function () {

  
if (window.matchMedia("(max-width: 767px)").matches) {
$('.product-logic-2 .surface-popup__action input').blur(function() {
var widthIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input').val()) || 0;
var widthFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__ft.surface_dimension_input input").val()) || 0;
var heightFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__ft.surface_dimension_input input").val()) || 0;
var heightIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val()) || 0;
if (
    (widthIn > 0 && heightIn > 0) ||  
    (widthIn > 0 && heightFt > 0) ||  
    (widthFt > 0 && heightIn > 0) ||  
    (widthFt > 0 && heightFt > 0)    
) {
   $('html, body').animate({ scrollTop: 0 }, 'slow');
}
  
});

} 
  
  $(document).on('paste keyup input', '.surface-popup__action input', debounce(function () {

      if ($(".surface-unit__item--in").hasClass("surface-unit__item--active")) {
      var widthIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input').val()) || 0;
      var widthFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__ft.surface_dimension_input input").val()) || 0;
      var heightFt = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__ft.surface_dimension_input input").val()) || 0;
      var heightIn = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val()) || 0;

    if (widthIn > 11) {
      $('.surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input').val(11)
      widthIn = 11;
    }
    if (heightIn > 11) {
      $('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val(11)
      heightIn = 11;
    }  

        
    if ((widthFt !== 0 || widthIn !== 0) && (heightFt === 0 && heightIn === 0)) {
        updatePrice(); 
        return; 
    }

    if ((heightFt !== 0 || heightIn !== 0) && (widthFt === 0 && widthIn === 0)) {
        updatePrice(); 
        return; 
    }

     if (widthFt === 0 && widthIn === 0 && heightFt === 0 && heightIn === 0) {
        updatePrice(); 
        return; 
     }
      
 
    let totalHeight = heightFt + parseFloat('0.'+ heightIn.toString() ); 
    let totalWidth = widthFt + parseFloat('0.'+ widthIn.toString() );
    
    totalHeight = parseFloat(totalHeight.toFixed(3));
    totalWidth = parseFloat(totalWidth.toFixed(3));
    
    let area = totalHeight * totalWidth;
    // var final = area * parseFloat(0.093)
    calculatedArea = parseFloat(area.toFixed(3))
      if (calculatedArea == 0) {
        calculatedArea = 1;  
      }
       calculatedArea = Math.ceil(calculatedArea);
      var priceText = $('.productView-price .price.price--medium span.price-item').html();
      var currency = priceText.match(/[^0-9.]+/g)[0];
      var numericPrice = priceText.replace(/[^0-9.]/g, '');
      var pricecal = parseFloat(numericPrice) * parseFloat(calculatedArea);
      var amountt = pricecal.toFixed(2);  // Fix price to 2 decimal points
      $('.aamount_sdd').html(`${currency}${amountt} USD`);
      if ($("button#product-add-to-cart .appended_prices").length > 0) {
        $("button#product-add-to-cart .appended_prices").html(`${currency}${amountt} USD`);
      } else {
        $("button#product-add-to-cart").append(
          `<span class="appended_prices">${currency}${amountt} USD</span>`
        );
      }
      $('.surface_space_row .quantity_selector quantity-input .quantity__container input').val(calculatedArea);
      $('input.send_data').val(calculatedArea);
      if(widthIn > 10){
      var incc_w = 0;
      }
      else{
       var incc_w = widthIn
      }

      if(heightIn > 10){
      var incc_h = 0;
      }
      else{
       var incc_h = heightIn
      }

      www = widthFt.toFixed(0);
      hhh = heightFt.toFixed(0);
      let vv = `${www}ft ${incc_w}in x ${hhh}ft ${incc_h}in`;
      $('input#SizeCustom').val(vv);
    

  } 
  
  // cm calculation
    
    else if ($(".surface-unit__item--cm").hasClass("surface-unit__item--active")) {

    var width_m = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__ft.surface_dimension_input input").val()) || 0;
    var width_cm = parseFloat($(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input").val()) || 0;
    var height_cm = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val()) || 0;
    var height_m = parseFloat($('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__ft.surface_dimension_input input').val()) || 0;

    if (height_cm > 98) {
      $('.surface-row__input.common_surface_dimension.surface-row__input--length .surface-input__in.surface_dimension_input input').val(99);
      height_cm = 99;
    }
    if (width_cm > 98) {
      $(".surface-row__input.common_surface_dimension.surface-row__input--width .surface-input__in.surface_dimension_input input").val(99);
      width_cm = 99;
    }
        
        
    if ((width_m !== 0 || width_cm !== 0) && (height_m === 0 && height_cm === 0)) {
        updatePrice(); 
        return; 
    }

    if ((height_m !== 0 || height_cm !== 0) && (width_m === 0 && width_cm === 0)) {
        updatePrice(); 
        return; 
    }

     if (width_m === 0 && width_cm === 0 && height_m === 0 && height_cm === 0) {
        updatePrice(); 
        return; 
     }


      var total_width_m = width_cm + (width_m * 100);
      var total_height_m = height_cm + (height_m * 100);
    
      
    calculatedArea = convert_into(total_width_m, total_height_m, "cm");

      if (calculatedArea == 0) {
        calculatedArea = 1;  
      }
      calculatedArea = Math.ceil(calculatedArea);
      var priceText = $('.productView-price .price.price--medium span.price-item').html();
      var currency = priceText.match(/[^0-9.]+/g)[0];
      var numericPrice = priceText.replace(/[^0-9.]/g, '');
      var pricecal = parseFloat(numericPrice) * parseFloat(calculatedArea);
      var amountt = pricecal.toFixed(2);  // Fix price to 2 decimal points
    
      $('.aamount_sdd').html(`${currency}${amountt} USD`);
      if ($("button#product-add-to-cart .appended_prices").length > 0) {
        $("button#product-add-to-cart .appended_prices").html(`${currency}${amountt} USD`);
      } else {
        $("button#product-add-to-cart").append(
          `<span class="appended_prices">${currency}${amountt} USD</span>`
        );
      }
    
      $('.surface_space_row .quantity_selector quantity-input .quantity__container input').val(calculatedArea);
      $('input.send_data').val(calculatedArea);
    

    let vv = `${width_m}m ${width_cm}cm x ${height_m}m ${height_cm}cm`;
    console.log(vv)
    $('input#SizeCustom').val(vv);

    let crop_size = Math.min(total_width_m, total_height_m);
    updateCropperBox("cm", crop_size, crop_size);
  }
   setTimeout(function() {
     // generateCroppedUrl();
     },100);
  init_cropper();
  if ($('#toggleMirror').is(':checked')) {
      $('#toggleMirror').click();
  }
}));


  $(document).on('click', '#toggleMirror', function() {
    isMirrored = !isMirrored;
    if (cropper) {
      cropper.scaleX(isMirrored ? -1 : 1);
    }
  });



$(document).on('afterChange', '.product .productView-nav , .productView-thumbnail-wrapper .productView-for', function(event, slick, currentSlide) {
    resetcropper();
});
});

function convertCmToPixels(cm, ppi = 96) {
  return (cm / 2.54) * ppi; 
}

function convertInchesToPixels(inches, ppi = 96) {
  return inches * ppi; 
}

function updateCropperBox(type, height, width) {
  console.log(type);
  console.log(height);
  console.log(width);
  
  init_cropper();
  setTimeout(function() {
    // generateCroppedUrl();
  }, 1500);
}

// Function to center the crop box
function centerCropBox() {
  var cropBoxData = cropper.getCropBoxData();
  var containerData = cropper.getContainerData();

  // Calculate new center position
  var newLeft = (containerData.width - cropBoxData.width) / 2;
  var newTop = (containerData.height - cropBoxData.height) / 2;

  cropper.setCropBoxData({
    left: newLeft,
    top: newTop
  });
}

// Function to generate cropped URL
function generateCroppedUrl() {
  if (cropper) {
    var croppedCanvas = cropper.getCroppedCanvas({
      width: 600, // Set desired width for the cropped image
      height: 400 // Set desired height for the cropped image
    });
    
    if (croppedCanvas) {
      var imgurl = croppedCanvas.toDataURL();
      uploadImage(imgurl);
    } else {
      $('input#CropPath').val('');
      console.error("Cropped canvas is null.");
    }
  }
}


$(document).on('focus', '.surface-popup__action input', function() {
  if ($(this).val() === "0") {
    $(this).val("");
  }
});

$(document).on('blur', '.surface-popup__action input', function() {
  if ($(this).val().trim() === "") {
    $(this).val("0");
  }
});


$(document).ready(function(){
 var priceText = $('.productView-price .price.price--medium span.price-item').html();
 $('span.aamount_sdd').html(priceText+' USD').show();
});


$(document).on("click", "button.btn-quantity", function (e) {
  var calculatedArea = parseInt(
    $(this).parents(".quantity__container").find('input[name="quantity"]').val()
  );
  $('input.send_data').val(calculatedArea);
  var priceText = $('.productView-price .price.price--medium span.price-item').html();
  var currency = priceText.match(/[^0-9.]+/g)[0];
  var numericPrice = priceText.replace(/[^0-9.]/g, '');
  var pricecal = parseInt(numericPrice) * parseInt(calculatedArea);
  var amountt = pricecal.toFixed(2);
  $("span.aamount_sdd").html(currency + amountt + " USD");
    if ($("button#product-add-to-cart .appended_prices").length > 0) {
    $("button#product-add-to-cart .appended_prices").html(`${currency}${amountt} USD`);
  } else {
    $("button#product-add-to-cart").append(
      `<span class="appended_prices">${currency}${amountt} USD</span>`
    );
  }
});

$(document).on("click","fieldset.product-form__input label.product-form__label",function () {
    var idd = $(this).attr("data-variant-id");
    $('.variant_dd[data-id!="' + idd + '"]').removeClass("active");
    $('.variant_dd[data-id="' + idd + '"]').addClass("active");
    var calculatedArea = $('input.send_data').val()
    var numericPrice = $('.variant_dd[data-id="' + idd + '"]').attr("variant-price");
  
    var pricecal = parseFloat(numericPrice) * parseInt(calculatedArea);
    var amountt = pricecal.toFixed(2);
    var currency = '$';
    $("span.aamount_sdd").html('$' + amountt + " USD");
   setTimeout(function() {
    if ($(".product-form__buttons button#product-add-to-cart .appended_prices").length > 0) {
    $(".product-form__buttons button#product-add-to-cart .appended_prices").html(`${currency}${amountt} USD`);
  } else {
    $(".product-form__buttons button#product-add-to-cart").append(`<span class="appended_prices">${currency}${amountt} USD</span>`);
  } 
 }, 1000);
});



